import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import naPortAutocompleteField from './NaPortAutocompleteField'

function NaAesPOEPortAutocompleteField(props) {
  return naPortAutocompleteField(
    props,
    CodeMaintenanceType.DOC_PORT,
    "AES_POE"
  )
}

export default NaAesPOEPortAutocompleteField